import { render } from "./AddFeesForm.vue?vue&type=template&id=0af3e298"
import script from "./AddFeesForm.vue?vue&type=script&lang=js"
export * from "./AddFeesForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__